import cs from 'classnames';

import type { IFieldProps } from '@/DesignSystem/Model/DataModel';

interface IProps extends IFieldProps {
  hasError: boolean;
  hasValue: boolean;
  fieldType?: string;
}

export const generateFieldClassNames = ({ className, size, hasError, hasValue, fieldType, color }: Partial<IProps>) => {
  return cs(
    'ui__field',
    'group/field',
    size && `ui__field--size-${size}`,
    hasError && `ui__field--has-error`,
    color && `ui__field--color-${color}`,
    hasValue && `ui__field--has-value`,
    fieldType && `ui__field--type-${fieldType}`,
    className,
  );
};
